// extracted by mini-css-extract-plugin
export default {"image":"Landing_image__wZt1w"};